// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__KZldY","l2":"styles_l2__qhm34"};